'use es6';

import RequestStatus from 'pricing-pages-unified-ui/constants/RequestStatus';
import { marketingContactsOnRenewalSelector } from 'pricing-pages-unified-ui/selectors/MarketingContactsSelectors';
import { isAppAuthSelector } from 'pricing-pages-unified-ui/selectors/ConfigSelectors';
import { numContactsInCrmSelector } from 'pricing-pages-unified-ui/selectors/ContactsSelectors';
import { fetchPromotionsStatus } from './PromotionSelectors';
import { fetchRequiredOnboardingStatus } from './RequiredOnboardingSelectors';
import { fetchPurchaseMotionStatus } from './PurchaseMotionSelectors';
import { fetchProductsStatus } from './ProductsSelectors';
import { fetchProductInventoryStatus } from './ProductInventorySelectors';

const numContactsSucceededCheck = state => {
  const numContactsInCrm = numContactsInCrmSelector(state);
  return numContactsInCrm !== null;
};

const marketingContactsOnRenewalSucceededCheck = state => {
  const isInApp = isAppAuthSelector(state);

  if (!isInApp) {
    return true;
  }

  const marketingContactsOnRenewal = marketingContactsOnRenewalSelector(state);
  return marketingContactsOnRenewal !== null && marketingContactsOnRenewal !== undefined;
}; // current required endpoint successes for page load success:
// products, promotions, required onboarding
// & numContactsInCrm, but only if on Marketing Hub Page


export const hasPricingAndPurchasingSucceededSelector = state => {
  const {
    promotions
  } = state;
  const isInApp = isAppAuthSelector(state);
  const requiredOnboardingStatus = fetchRequiredOnboardingStatus(state);
  const productsStatus = fetchProductsStatus(state);
  const productInventoryComplete = fetchProductInventoryStatus(state) === RequestStatus.SUCCEEDED || !isInApp;
  return productsStatus === RequestStatus.SUCCEEDED && productInventoryComplete && !!promotions.productsEligibleForDirectPromotions && numContactsSucceededCheck(state) && marketingContactsOnRenewalSucceededCheck(state) && requiredOnboardingStatus === RequestStatus.SUCCEEDED;
};
export const hasPricingAndPurchasingFailedSelector = state => {
  const productsStatus = fetchProductsStatus(state);
  const productInventoryStatus = fetchProductInventoryStatus(state);
  const promotionsStatus = fetchPromotionsStatus(state);
  const requiredOnboardingStatus = fetchRequiredOnboardingStatus(state);
  const canCheckForMarketingContactsOnRenewal = productsStatus === RequestStatus.SUCCEEDED && productInventoryStatus === RequestStatus.SUCCEEDED;
  return productsStatus === RequestStatus.FAILED || productInventoryStatus === RequestStatus.FAILED || promotionsStatus === RequestStatus.FAILED || !numContactsSucceededCheck(state) || canCheckForMarketingContactsOnRenewal && !marketingContactsOnRenewalSucceededCheck(state) || requiredOnboardingStatus === RequestStatus.FAILED;
};
export const hasPurchaseMotionsSucceededSelector = state => {
  const purchaseMotionStatus = fetchPurchaseMotionStatus(state);
  return purchaseMotionStatus === RequestStatus.SUCCEEDED;
};
export const hasPurchaseMotionsFailedSelector = state => {
  const purchaseMotionStatus = fetchPurchaseMotionStatus(state);
  return purchaseMotionStatus === RequestStatus.FAILED;
};
export const hasProductsSucceededSelector = state => {
  const productsStatus = fetchProductsStatus(state);
  return productsStatus === RequestStatus.SUCCEEDED;
};
export const hasPromotionsSucceededSelector = state => {
  const promotionsStatus = fetchPromotionsStatus(state);
  return promotionsStatus === RequestStatus.SUCCEEDED;
};
export const isMerchCardCTAsDataLoadingSelector = state => {
  const hasPurchaseMotionsSucceeded = hasPurchaseMotionsSucceededSelector(state);
  const hasProductsSucceeded = hasProductsSucceededSelector(state);
  const hasPromotionsSucceeded = hasPromotionsSucceededSelector(state);
  return !hasPurchaseMotionsSucceeded || !hasProductsSucceeded || !hasPromotionsSucceeded;
};
export const hasOfferDataLoadedSelector = state => {
  const hasProductsSucceeded = hasProductsSucceededSelector(state);
  const hasPromotionsSucceeded = hasPromotionsSucceededSelector(state);
  return hasProductsSucceeded && hasPromotionsSucceeded;
};